import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { IMapHouseContextFields } from '../../map.types'
import { breakpoints, Map, useMediaQuery } from '../../../../..'
import { MapHouseCard } from '../../../../..'

export const MapComponent = ({
  housesGallery,
  isFetching,
  onClickHouse,
  isActiveSearch,
  zoomOnLoad = false,
  className,
  mapHoveredHouse,
  hideZoomControls,
  setMapHoveredHouse,
  setMapGoToRef,
}: {
  housesGallery: IMapHouseContextFields[]
  isFetching: boolean
  onClickHouse: (id: string) => Promise<void>
  isActiveSearch: boolean
  zoomOnLoad?: boolean
  className?: string
  mapHoveredHouse?: string
  hideZoomControls?: boolean
  setMapHoveredHouse: React.Dispatch<React.SetStateAction<string | undefined>>
  setMapGoToRef: React.Dispatch<React.SetStateAction<string | undefined>>
}) => {
  const isMobile = useMediaQuery(breakpoints.newMobile)
  if (!housesGallery || isFetching) {
    return null
  }

  const mapClassName = () => {
    if (isMobile) {
      return s.mobileMapContainer
    } else if (className) {
      return className
    } else if (isActiveSearch) {
      return s.containerMapSearch
    } else {
      return s.containerMap
    }
  }

  return (
    <div className={clsx(mapClassName())}>
      <Map
        dataMatchs={housesGallery.map((item) => ({ house: item }))}
        onClickItem={onClickHouse}
        zoomOnLoad={zoomOnLoad}
        CardElement={MapHouseCard}
        mapHoveredHouse={mapHoveredHouse}
        setMapHoveredHouse={setMapHoveredHouse}
        hideZoomControls={hideZoomControls}
        setMapGoToRef={setMapGoToRef}
      />
    </div>
  )
}
